import { apiClient } from '@/lib/api-client';

export interface VoucherValidateResponse {
  valid: boolean;
  voucher_id: string;
  code: string;
  type: 'PERCENTAGE' | 'FLAT';
  discount_amount: number;
  message: string;
  /** C03: the voucher is only for some items; the money comes off those lines only. */
  scoped?: boolean;
  /** The bill's products the voucher covers (scoped vouchers). */
  eligible_product_ids?: string[];
  /** "Snacks" for a category voucher, else "matching" — used in the till's messages. */
  scope_label?: string;
}

/** One bill line for a voucher check: its product and its net after its own discount (minor units). */
export interface VoucherValidateLine {
  product_id: string;
  amount: number;
}

export interface VoucherRedeemResponse {
  redemption_id: string;
  voucher_id: string;
  voucher_code: string;
  bill_id: string;
  discount_amount: number;
  updated_bill_total: number;
  redeemed_at: string;
}

export const vouchersService = {
  validate(input: {
    code: string;
    bill_amount: number;
    location_id: string;
    customer_id?: string;
    lines?: VoucherValidateLine[];
  }) {
    return apiClient<VoucherValidateResponse>('/vouchers/validate', {
      method: 'POST',
      body: input,
    });
  },

  redeem(code: string, input: { bill_id: string; customer_id?: string }) {
    return apiClient<VoucherRedeemResponse>(`/vouchers/${encodeURIComponent(code)}/redeem`, {
      method: 'POST',
      body: input,
    });
  },
};
